import { carouselData } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm">深度追踪重磅吃瓜事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer hover:shadow-lg transition-shadow duration-300 flex flex-col"
            >
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="mb-2">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-foreground-800 font-bold text-sm md:text-base leading-snug mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed flex-1">
                  {item.summary}
                </p>
                <div className="mt-3 flex items-center text-primary-500 text-xs font-medium cursor-pointer">
                  <span>阅读全文</span>
                  <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}